import React, { useContext } from "react";
import Image from "next/image";
import { useUser } from "@auth0/nextjs-auth0/client";

import * as styles from "./header.css";
import { Grid, Paper, Typography } from "@mui/material";
import Link from "next/link";
import { ReportContext } from "contexts/reportContext";
import ContextMenu from "components/ContextMenu";
import { clsx } from "uikit/utils";

interface HeaderProps {
  logoShown?: boolean;
  type?: "small" | "normal";
}

export default function Header({ logoShown, type }: Readonly<HeaderProps>) {
  const { user } = useUser();
  const { uploads } = useContext(ReportContext);

  return (
    <Paper component="header" elevation={3} className={styles.wrapper}>
      <div className={styles.header({ type: type ?? "normal" })}>
        {logoShown && (
          <a href="/" className={styles.logoWrapper}>
            <Image src="/icon.svg" width={30} height={30} alt="FinTrack" />
            <span>StatAnalyzer</span>
          </a>
        )}
        <Grid container component="nav" justifyContent="flex-end" gap="2rem">
          {user && <Typography>Uploads left: {uploads}</Typography>}
          <Link href="/pricing" className={styles.link}>
            Pricing
          </Link>
          <Link href="/demo" className={clsx(styles.link, styles.hideInMobile)}>
            Demo
          </Link>
          <Link
            href="/#how-it-works"
            className={clsx(styles.link, styles.hideInMobile)}
          >
            How it works?
          </Link>
          {!user ? (
            <a href={`/api/auth/login`} className={styles.link}>
              Login
            </a>
          ) : (
            <ContextMenu />
          )}
        </Grid>
      </div>
    </Paper>
  );
}
